import React, { useCallback } from 'react';

import { AnalyticsListener, type UIAnalyticsEvent } from '@atlaskit/analytics-next';

import { useFirePostOfficeTrigger } from '@atlassian/post-office-context';

type PostOfficeAnalyticsListenerProps = {
	children: React.ReactNode;
};

const GASV3_DWELL_TRIGGER_TIME = 40000; // ms
const PO_DWELL_TRIGGER_TIME = 60000; // ms

export const PostOfficeAnalyticsListener = ({ children }: PostOfficeAnalyticsListenerProps) => {
	const { fireTrigger } = useFirePostOfficeTrigger({ triggerId: 'confluence-page-dwelled' });

	const onEvent = useCallback(
		(event: UIAnalyticsEvent) => {
			if (
				event.payload?.data?.action === 'dwelled' &&
				event.payload?.data?.actionSubject === 'page'
			) {
				const dwellTime = event.payload.data.attributes?.dwellTime;

				// Dwell events are triggered at 5, 10, 20, 40, 80s, but we want 60s
				if (event.payload.data.attributes?.finalDwellEvent) {
					fireTrigger({ isActive: false });
				} else if (
					dwellTime &&
					dwellTime >= GASV3_DWELL_TRIGGER_TIME &&
					dwellTime <= PO_DWELL_TRIGGER_TIME
				) {
					fireTrigger({ isActive: true });
				}
			}
		},
		[fireTrigger],
	);

	return (
		<AnalyticsListener onEvent={onEvent} channel="*">
			{children}
		</AnalyticsListener>
	);
};
